export function entityToStore(entity) {
  return entity.charAt(0).toLowerCase() + entity.slice(1);
}

export function getOptionDescription(store, optionGroup, optionCode) {
  const option =
    optionCode !== null && store.getters['option/loadedOptions'](optionGroup).find(item => item.code === optionCode);
  return option && option.description;
}
